import {ActionEnum} from "../action.enum";
import {ServiceProviderModel} from "../../models/service_provider/service-provider.model";

export namespace ServiceProviderDetailAction {

  export class Fetch {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DETAIL_FETCH;
    constructor (public id: string) {}
  }

  export class UpdateState {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DETAIL_UPDATE_STATE;
    constructor(public serviceProvider: ServiceProviderModel) {}
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DETAIL_SAVE;
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.SERVICE_PROVIDER_DETAIL_RESET;
  }

}
